import {
  SIGN_IN,
  SIGN_OUT,
  SET_USER_SETTING,
  SET_RESTORE_LOGIN,
  SET_CURRENT_LANGUAGE,
  SIGN_IN_LOADING_STATUS,
  SET_WALLET_NAME,
} from 'store/actions/actionTypes';
import { loadState } from 'utils';
import config from 'configs';

const loadLanguage = loadState('lang');

const lang = config.languages.includes(loadLanguage) ? loadLanguage : config.languages[0] || 'en';

const defaultState = {
  lang,
  isLoggedIn: false,
  restoreLogin: false,
  walletName: '',
  userSettings: {
    image: '',
    address: '',
    username: '',
    loginFinished: false,
  },
};

function authReducer(state = defaultState, action) {
  switch (action.type) {
    case SIGN_IN_LOADING_STATUS: {
      return {
        ...state,
        loadingStatus: action.payload,
      };
    }
    case SET_CURRENT_LANGUAGE: {
      return {
        ...state,
        lang: action.payload,
      };
    }
    case SET_WALLET_NAME: {
      return {
        ...state,
        walletName: action.payload,
      };
    }
    case SET_RESTORE_LOGIN: {
      return {
        ...state,
        restoreLogin: action.payload,
      };
    }
    case SIGN_IN:
      return {
        ...state,
        isLoggedIn: true,
      };
    case SIGN_OUT:
      return {
        ...state,
        ...defaultState,
        userSettings: { ...defaultState.userSettings, loginFinished: true },
        lang: state.lang,
      };
    case SET_USER_SETTING:
      return {
        ...state,
        userSettings: {
          ...state.userSettings,
          ...action.payload,
        },
      };
    default:
      return state;
  }
}

export default authReducer;
